import React from "react";
import { ClipboardCheck, BookOpen, Award, Briefcase } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: ClipboardCheck,
    title: "Iscriviti",
    text: "Scegli il pacchetto più adatto, compila la domanda e ricevi la tua tessera ACDT.",
  },
  {
    n: "02",
    icon: BookOpen,
    title: "Forma le tue competenze",
    text: "Accedi al Corso A.C.D.T. per la qualificazione professionale (20 moduli) e ai materiali didattici riservati.",
  },
  {
    n: "03",
    icon: Award,
    title: "Certifica le tue abilità",
    text: "Ottieni attestato, Crediti Formativi (CFP) e badge digitale ACDT.",
  },
  {
    n: "04",
    icon: Briefcase,
    title: "Esercita la professione",
    text: "Iscriviti al Registro Agg. MIMIT, ottieni timbro e carta intestata. Inizia a operare.",
  },
];

export default function HowItWorks() {
  return (
    <section id="come-funziona" className="relative py-24 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
            Come funziona
          </div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0a1f55] leading-[1.05]">
            Dal primo click alla<br className="hidden md:block" /> tua nuova{" "}
            <span className="text-[#102a6b]">professione</span>
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Un percorso strutturato in 4 step semplici e progressivi.
          </p>
        </div>

        <div className="mt-14 relative">
          {/* connecting line */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#102a6b]/20 to-transparent"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.n}
                  className="reveal group relative"
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  <div className="relative rounded-2xl bg-white border border-slate-200 p-6 lift">
                    <div className="relative h-14 w-14 rounded-xl bg-gradient-to-br from-[#102a6b] to-[#1e40af] text-white flex items-center justify-center shadow-lg shadow-[#102a6b]/20">
                      <Icon className="h-6 w-6" />
                      <span className="absolute -top-2 -right-2 h-7 w-7 rounded-full bg-[#f59e0b] text-[#0a1f55] flex items-center justify-center text-[11px] font-extrabold border-2 border-white">
                        {s.n}
                      </span>
                    </div>
                    <h3 className="mt-5 text-lg font-extrabold text-[#0a1f55]">{s.title}</h3>
                    <p className="mt-2 text-[14px] text-slate-600 leading-relaxed">{s.text}</p>
                    <div className="mt-4 h-[3px] w-10 rounded-full bg-gradient-to-r from-[#102a6b] to-[#f59e0b] group-hover:w-20 transition-all duration-500"></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
